export default __webpack_public_path__ + "static/media/diners-club.94252893.svg";